import { render } from "./ScoreTable.vue?vue&type=template&id=0bbe2d3c&scoped=true"
import script from "./ScoreTable.vue?vue&type=script&lang=js"
export * from "./ScoreTable.vue?vue&type=script&lang=js"

import "./ScoreTable.vue?vue&type=style&index=0&id=0bbe2d3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbe2d3c"]])

export default __exports__